import { FuelTypography } from '@frete.com/fuel-react';
import GenericInfoItem from 'components/ui/GenericInfoItem';
import { textConstants } from 'constants/texts';
import { IAvailability } from 'interfaces/profile.interface';
import React, { FC } from 'react';

const TruckerAvailability: FC<IAvailability> = ({ originLocation, originUF, locationType }) => {
  const { noInfoText } = textConstants;

  const getLocationText = () => {
    if (!locationType || (locationType && !originLocation && !originUF)) return noInfoText;

    if (locationType === 'region' || locationType === 'state') return originLocation;

    return `${originLocation}, ${originUF}`;
  };

  return (
    <GenericInfoItem title="Buscando fretes saindo de">
      <FuelTypography weight="medium">{getLocationText()}</FuelTypography>
    </GenericInfoItem>
  );
};

export default TruckerAvailability;
